import { ClassificationTask } from '@idea2app/ai-work-order-service';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { Filter } from 'mobx-restful';
import { Column, Field, RestTable } from 'mobx-restful-table';
import { Component } from 'react';
import { Badge, Card } from 'react-bootstrap';

import classificationTaskStore, {
    AICapabilityLabels,
    TaskStatusColors,
    TaskStatusLabels
} from '../model/ClassificationTask';
import { i18n, I18nKey, t } from '../model/Translation';

@observer
export class ClassificationTaskListPage extends Component {
    @computed
    get filterFields(): Field<Filter<ClassificationTask>>[] {
        return [
            { key: 'name', renderLabel: t('task_name') },
            {
                key: 'status',
                type: 'select',
                renderLabel: t('task_status'),
                options: [
                    { value: '', label: t('all_statuses') },
                    { value: 'in_progress', label: t('task_in_progress') },
                    { value: 'completed', label: t('task_completed') },
                    { value: 'failed', label: t('task_failed') }
                ]
            }
        ];
    }

    @computed
    get columns(): Column<ClassificationTask>[] {
        return [
            {
                key: 'id',
                type: 'number',
                renderHead: t('task_id')
            },
            {
                key: 'name',
                renderHead: t('task_name')
            },
            {
                key: 'aiCapabilities',
                renderHead: t('ai_capabilities'),
                renderBody: ({ aiCapabilities }) =>
                    aiCapabilities?.map(cap => (
                        <Badge key={cap} bg="info" className="me-1">
                            {t(AICapabilityLabels[cap] as I18nKey)}
                        </Badge>
                    ))
            },
            {
                key: 'status',
                renderHead: t('task_status'),
                renderBody: ({ status }) => (
                    <Badge bg={TaskStatusColors[status]}>
                        {t(TaskStatusLabels[status] as I18nKey)}
                    </Badge>
                )
            },
            {
                key: 'totalWorkOrders',
                type: 'number',
                renderHead: t('total_work_orders'),
                renderBody: ({ totalWorkOrders }) => totalWorkOrders || 0
            },
            {
                key: 'processedWorkOrders',
                type: 'number',
                renderHead: t('processed_work_orders'),
                renderBody: ({ processedWorkOrders }) =>
                    processedWorkOrders || 0
            },
            {
                key: 'startedAt',
                renderHead: t('started_at'),
                renderBody: ({ startedAt }) =>
                    startedAt ? new Date(startedAt).toLocaleString() : '-'
            },
            {
                key: 'endedAt',
                renderHead: t('ended_at'),
                renderBody: ({ endedAt }) =>
                    endedAt ? new Date(endedAt).toLocaleString() : '-'
            },
            {
                renderHead: t('actions'),
                renderBody: ({ id }) => (
                    <a href={`#/task/classification/${id}`}>
                        {t('view_details')}
                    </a>
                )
            }
        ];
    }

    render() {
        return (
            <Card className="m-3" body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2>{t('classification_task_list')}</h2>
                </div>
                <RestTable
                    filterFields={this.filterFields}
                    columns={this.columns}
                    store={classificationTaskStore}
                    translator={i18n}
                    striped
                    hover
                />
            </Card>
        );
    }
}
